import config from "config/config";
import type { StickyBottomBarStyles } from "../StickyBottomBar.d";

export const stickyBottomBarDesktopStyles: StickyBottomBarStyles = {
  basic: {
    container: {
      bg: "primary.500",
    },
    innerContainer: {
      flexDir: "column",
    },
    innerSubContainer: { mt: 2 },
    heading: { flex: 1, color: "greyscale.100", mr: 4, alignSelf: "center" },
    actionButton: {
      bg: "greyscale.100",
      color: "primary.500",
      ml: "auto",
      alignSelf: "center",
    },
    closeButton: {
      right: -6,
      top: -6,
    },
    benefits: { display: "flex" },
    logo: { display: "none" },
  },
  ahPlus: {
    container: {
      bg: "greyscale.400",
      p: 10,
      bgRepeat: "no-repeat",
      bgImage: `url(${config.staticUrl}/i/airhelp-plus/sticky-bottom-bar-bg-image.png)`,
      backgroundPositionX: { lg: "500px", xl: "110%" },
      bgSize: "contain",
    },
    innerContainer: {
      flexDir: "row",
    },
    headingContainer: { flex: 2, alignSelf: "center" },
    heading: { color: "primary.900", maxW: "450px" },
    actionButton: { bg: "secondary.500", color: "greyscale.100", alignSelf: "center" },
    closeButton: {
      right: -9,
      top: -9,
    },
    benefits: { display: "none" },
    logo: { width: "149px", height: "32px", mr: 5, alignSelf: "stretch", mt: 1 },
  },
};
